<template>
  <rest
    :remote="remote"
    :table-columns="tableColumns"
    :formInitialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :export-visible="true"
    :use-drawer="true"
    drawer-width="50%"
    :create-able="true" :update-able="true" :delete-able="true"
    :appIdFilter="true"
    :app-id-filter-fields="['gameId']"
  >
  </rest>
</template>

<script>

import Rest from '@/components/Spring/Rest'

export default {
  name: 'telecomAuths',
  components: { Rest },

  data () {
    return {
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: false,
        reloadUrl: '/channel/admin/cache/reload/telecom/auth',
        reloadLabel: '重载NACOS-电信认证'
      },
      formRules: {
        gameId: [{ required: true, message: '请选择 游戏ID' }],
        pkgName: [{ required: true, message: '请填写 包名' }],
        appId: [{ required: true, message: '请填写电信 AppId' }],
        appSecret: [{ required: true, message: '请填写 appSecret' }],
        publicKey: [{ required: true, message: '请填写 publicKey' }]
      },
      listeners: {
      }
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    appOptions () {
      return this.$store.getters.appOptions
    },
    formInitialize () {
      return {
        gameId: this.appId,
        pkgName: '',
        appId: '',
        appSecret: '',
        publicKey: ''
      }
    },
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', hiddenForm: true },
        { label: '游戏', prop: 'gameId', type: 'select', options: this.appOptions },
        { label: '包名', prop: 'pkgName' },
        { label: '电信 AppId', prop: 'appId', placeholder: '请填写电信分配的 AppId' },
        { label: 'AppSecret', prop: 'appSecret' },
        { label: 'PublicKey', prop: 'publicKey', type: 'textarea' }
      ]
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>
